import React , { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch } from "react-redux";
import {Card, Grid, Typography} from '@material-ui/core';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import { ListaContactos } from './ListaMoviminetoUser';
import { buscarMovimientoUser, traerMovimientosUser} from "../../actions/movimientosUser/movimientosUser";

const useStyles = makeStyles({
    root:{
        width:400,
        margin:30,
        padding:20
    },
    paper: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    buttonOk:{
      margin:10
    }
});

export const HomeMovimientosUser = () => {

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect (() => {
      dispatch( traerMovimientosUser());
    }, [dispatch])

    const handleChange = e => {
      dispatch(buscarMovimientoUser(e.target.value));
    }

    const handleKeyPress = e => {
      if (e.which === 13) 
          e.preventDefault();
    }

 

    return (
        <div>
          <Grid> 
            <Grid container justify="center">
              <Card className={classes.root}>  
                  <Grid container ><Typography ><strong>Buscar Usuario</strong></Typography></Grid>
                  <Paper component="form" className={classes.paper}>
                    <InputBase
                      className={classes.input}
                      placeholder="Usuario"
                      onChange={handleChange}
                      onKeyPress={handleKeyPress}
                    />
                  </Paper>
              </Card>
            </Grid>  
           <ListaContactos />
          </Grid>
        </div>
      );
  
  };
  